import React from "react";
import ColorChoiceGrid from "./ColorChoiceGrid";
import "./ColorChoiceComponent.css";

const ColorChoiceComponent = () => {
  const row1Ids = ["4.1.a", "4.1.b", "4.1.c", "4.1.d", "4.1.e", "4.1.f"];
  const row2Ids = ["4.2.a", "4.2.b", "4.2.c", "4.2.d"];
  const row3Ids = ["4.3.a", "4.3.b", "4.3.c", "4.3.d", "4.3.e", "4.3.f"];

  const row1Images = [
    "colors/Antracyt.jpg",
    "colors/Braz.jpg",
    "colors/Jasnybraz.jpg",
    "colors/Srebrny.jpg",
    "colors/Czarny.jpg",
    "colors/Bialy.jpg",
  ];

  const row2Images = [
    "colors/Antracyt.jpg",
    "colors/Braz.jpg",
    "colors/Srebrny.jpg",
    "colors/Czarny.jpg",
  ];

  const row3Images = [
    "colors/Antracyt.jpg",
    "colors/Braz.jpg",
    "colors/Jasnybraz.jpg",
    "colors/Srebrny.jpg",
    "colors/Czarny.jpg",
    "colors/Bialy.jpg",
  ];

  const row1Names = ["RAL 7016 (Antracyt)", "RAL 8017 (Brązowy)", "RAL 8003 (Jasny Brąz)", "RAL 9006 (Srebrny)", "RAL 9005 (Czarny)", "RAL 9003 (Biały)"];
  const row2Names = ["RAL 7016 (Antracyt)", "RAL 8017 (Brązowy)", "RAL 9006 (Srebrny)", "RAL 9005 (Czarny)"];
  const row3Names = ["RAL 7016 (Antracyt)", "RAL 8017 (Brązowy)", "RAL 8003 (Jasny Brąz)", "RAL 9006 (Srebrny)", "RAL 9005 (Czarny)", "RAL 9003 (Biały)"];

  return (
    <div className="flex-wrap color-choice-container">
      <h3 className="header-text">Kolor słupów</h3>
      <ColorChoiceGrid ids={row1Ids} images={row1Images} names={row1Names} category="poleColor" />

      <h3 className="header-text">Kolor dachu</h3>
      <ColorChoiceGrid ids={row2Ids} images={row2Images} names={row2Names} category="roofColor" />

      <h3 className="header-text">Kolor maskownicy</h3>
      <ColorChoiceGrid ids={row3Ids} images={row3Images} names={row3Names} category="facadeColor" />
    </div>
  );
};

export default ColorChoiceComponent;
